import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_CANCELLATION_PERIOD_TITLE,
	ONBOARDING_ERROR_CANCELLATION_PERIOD_DESCRIPTION,
	ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
} from '../../../../constants/Copy';
import { ROUTE_HOME } from '../../../../constants/Routes';

const DefaultCancellationPeriodError = (props) => (
	<FullPageMessage
		button={{
			onClick: () => props.history.push(ROUTE_HOME),
			testValue: ROUTE_HOME,
			text: ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
		}}
		title={ONBOARDING_ERROR_CANCELLATION_PERIOD_TITLE}
		description={ONBOARDING_ERROR_CANCELLATION_PERIOD_DESCRIPTION}
	/>
);

DefaultCancellationPeriodError.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultCancellationPeriodError;
